// AngularJS

// external
export abstract class LazyLoadService {
  [key: string]: any;
}
export const $lazyLoadProvider = {
  provide: LazyLoadService,
  useFactory: function ($injector: any) {
    return $injector.get('$ocLazyLoad');
  },
  deps: ['$injector'],
};

// common-header
export abstract class HelpWidgetFactory {
  [key: string]: any;
}
export const helpWidgetFactoryProvider = {
  provide: HelpWidgetFactory,
  useFactory: function ($injector: any) {
    return $injector.get('helpWidgetFactory');
  },
  deps: ['$injector'],
};

export abstract class LoadingService extends Function {
  [key: string]: any;
}
export const loadingServiceProvider = {
  provide: LoadingService,
  useFactory: function ($injector: any) {
    return $injector.get('$loading');
  },
  deps: ['$injector'],
};

// common/services
export abstract class CompanyAssetsService {
  [key: string]: any;
}
export const companyAssetsServiceProvider = {
  provide: CompanyAssetsService,
  useFactory: function ($injector: any) {
    return $injector.get('companyAssetsFactory');
  },
  deps: ['$injector'],
};

// components/gapi
export abstract class GapiLoader {
  abstract load(): Promise<any>;
}

export abstract class CoreAPILoader {
  abstract load(): Promise<any>;
}

// components/logging
export abstract class ExceptionHandler extends Function {
  [key: string]: any;
}
export const exceptionHandlerProvider = {
  provide: ExceptionHandler,
  useFactory: function ($injector: any) {
    return $injector.get('$exceptionHandler');
  },
  deps: ['$injector'],
};

export abstract class AnalyticsFactory {
  [key: string]: any;
}
export const analyticsFactoryProvider = {
  provide: AnalyticsFactory,
  useFactory: function ($injector: any) {
    return $injector.get('analyticsFactory');
  },
  deps: ['$injector'],
};

export abstract class BigQueryLogging {
  [key: string]: any;
}
export const bigQueryLoggingProvider = {
  provide: BigQueryLogging,
  useFactory: function ($injector: any) {
    return $injector.get('bigQueryLogging');
  },
  deps: ['$injector'],
};

// components/scrolling-list
export abstract class ProcessErrorCode extends Function {}
export const processErrorCodeProvider = {
  provide: ProcessErrorCode,
  useFactory: function ($injector: any) {
    return $injector.get('processErrorCode');
  },
  deps: ['$injector'],
};

export abstract class ScrollingListService extends Function {}
export const scrollingListServiceProvider = {
  provide: ScrollingListService,
  useFactory: function ($injector: any) {
    return $injector.get('ScrollingListService');
  },
  deps: ['$injector'],
};

// components/userstate
export abstract class UrlStateService {
  [key: string]: any;
}
export const urlStateServiceProvider = {
  provide: UrlStateService,
  useFactory: function ($injector: any) {
    return $injector.get('urlStateService');
  },
  deps: ['$injector'],
};

export abstract class CanAccessApps extends Function {}
export const canAccessAppsProvider = {
  provide: CanAccessApps,
  useFactory: function ($injector: any) {
    return $injector.get('canAccessApps');
  },
  deps: ['$injector'],
};
